import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=095ac0ab"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('095ac0ab')) {
      api.createRecord('095ac0ab', component.options)
    } else {
      api.reload('095ac0ab', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=095ac0ab", function () {
      api.rerender('095ac0ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/goods/sku/ordinary/edit.vue"
export default component.exports